import cn from 'classnames';
import { DetailedHTMLProps, FC, ReactNode } from 'react';

import { useMedia } from '@/shared/hooks';

import { Skeleton } from '../Skeleton/Skeleton';

import styles from './WidgetCard.module.scss';

type WidgetCardProps = DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
> & {
  className?: string;
  children?: ReactNode;
  loading?: boolean;
  id?: string;
  setNodeRef?: (node: HTMLElement | null) => void;
};

export const WidgetCard: FC<WidgetCardProps> = (props) => {
  const { className, children, loading, id, setNodeRef, ...rest } = props;

  const isMobile = useMedia();

  return loading ? (
    <Skeleton
      width="100%"
      borderRadius="16px"
      height={isMobile ? '164px' : '320px'}
    />
  ) : (
    <section
      ref={setNodeRef}
      className={cn(styles.container, className)}
      id={id}
      {...rest}
    >
      {children}
    </section>
  );
};
